<template>
    <div class="reserve-usage-history">
      <ul class="reserve-usage-history__list" v-if="reservation_node.length > 0">
        <li class="reserve-usage-history__lists" v-for="node in reservation_node" :key="node">
          <p class="reserve-usage-history__item d-flex align-items-center"><span class="reserve-usage-history__icon reserve-usage-history__icon--blue">完了</span><span class="reserve-usage-history__category">{{ node.label }}</span></p>
          <p class="reserve-usage-history__description">
            {{ node.start_date_str }} {{ youbi(node) }}
            <span v-for="item in node.item_data" :key="item">
                {{ item.start_time_str }} - {{ item.end_time_str }}/
            </span>
            </p>
        </li>
      </ul>
      <div v-else>
        履歴はありません。
      </div>
    </div>
</template>

<script>
// import BsPageTitle from '../molecules/BsPageTitle.vue'
import { mapState } from 'vuex';
import moment from 'moment'
export default {
    name: 'ListHistoryView',
    data: function () {
        return {
        }
    },
    props: {
        // displayClass: {
        //     type: String,
        //     default: 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
        // },
    },
    components: {
        // BsPageTitle,
    },
    methods: {
        loadReservationNode () {
            const params = {};
            params['type'] = 'lodge';
            params['use_m_id'] = this.$store.state.auth.userId;
            params['stat'] = [10];
            // params['end_date'] = moment().format('YYYY-MM-DD');
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'reservation_node'})
                        .catch(err => Promise.reject(err))
                        .then(() => {
                            console.log('loard complete reservation_node');
                            console.log('this', this.$store.state.apidata.reservation_node);
                        })
                        .finally(() => {
                            console.log('finally', this.$store.state.apidata.reservation_node);
                        })
        },
    },
    computed: {
        ...mapState({
            reservation_node: state => state.apidata.reservation_node,
            // paddock_list: state => state.apidata.drive_node_category,
        }),
        youbi: function (){
            return function(node){
                return moment(node.start_date_str).format("ddd");
            }
        }
    },

    created () {
        this.loadReservationNode();
        // this.loaddriveNode();
        // this.loadLedgerType();
    },
}
</script>
